"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEditorContainer = exports.default = void 0;
var product_editor_container_1 = require("./product-editor.container");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(product_editor_container_1).default; } });
Object.defineProperty(exports, "ProductEditorContainer", { enumerable: true, get: function () { return product_editor_container_1.ProductEditorContainer; } });
